import { swishApp } from "/apps/wishlist/assets/sdk@0.53.0/swish.js";

const swish = await swishApp({
  proxy: {
    baseUrl: "/apps/wishlist",
  },
  ui: {
    baseUrl: "/apps/wishlist/assets",
    // baseUrl: "https://swishapp-max.ngrok.io/assets",
    version: "9173072",
  },
  storefront: {
    storeDomain: location.host,
    accessToken: "250f1147eacd8ea87a32023fc6e5e3e6",
  },
});

// Trigger drawer from URL param
const swishParam = new URLSearchParams(window.location.search).get("swish");
if (swishParam === "hub") {
  // TODO: Move this to SDK and use intents
  swish.ui.showDrawer();
}

if (swishParam) {
  const url = new URL(window.location.href);
  url.searchParams.delete("swish")
  window.history.replaceState({}, document.title, url.toString());
}


const selectors = {
  
  saveButtons: ".swish-save-button",
};

// Drawer button

swish.dom.createElementLocator({
  selector: ".swish-drawer-button",
  onElementFound: initDrawerButton,
});

function initDrawerButton(element) {
  const state = swish.state.itemCount();

  element.addEventListener("click", () => {
    swish.ui.showDrawer();
  });

  swish.state.effect(() => {
    const { loading, count } = state.value;

    element.classList.toggle("has-items", count > 0);
  });
}

// Save Buttons

swish.dom.createElementLocator({
  selector: ".swish-save-button",
  onElementFound: initSaveButton,
  observerOptions: {
    rootMargin: "50% 0%",
  }
});

function initSaveButton(element) {
  const context = swish.state.itemContext(element);
  const state = swish.state.itemState(context);
  
  element.addEventListener("click", () => {
    state.toggle();
  });

  swish.state.effect(() => {
    const { loading, saved, saving } = state.value;

    element.classList.toggle("loading", loading);
    element.classList.toggle("saved", saved || saving);
    element.setAttribute("aria-pressed", saved);
    element.setAttribute("aria-label", saved ? "Remove item" : "Save item");

    if (element.querySelector(".swish-text")) {
      element.querySelector(".swish-text").textContent = saved || saving ? "In Wishlist" : "Add to Wishlist";
    }
  });
}